import React from 'react';
import { IOBOAccount } from '../../models/obo-account';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
interface IAccountSelectorProps {
    AccountType: string;
    Accounts: IOBOAccount[];
    onAccountSelection: (event: any) => void;
    selectedAccount: string;
}

const AccountSelector = ({
    AccountType,
    Accounts,
    onAccountSelection,
    selectedAccount,
}: IAccountSelectorProps) => {
    const intl = useIntl();
    return (
        <div>
            <label>
                {intl.formatMessage(
                    {
                        id: 'Select_a_X',
                        defaultMessage: 'Select a {0}',
                    },
                    {
                        0: AccountType,
                    }
                )}
                :
            </label>
            <select
                onChange={onAccountSelection}
                value={selectedAccount}
                name={AccountType}
                className="form-control"
            >
                {Accounts.map((Account) => {
                    return (
                        <option
                            key={Account.accountNumber}
                            value={Account.accountNumber.split(' -')[0]}
                        >
                            {Account.accountNumber}
                        </option>
                    );
                })}
            </select>
            {selectedAccount && (
                <>
                    <p
                        style={{
                            textAlign: 'initial',
                            marginLeft: '15px',
                            marginTop: '10px',
                        }}
                    >
                        {
                            Accounts.find(
                                (x) =>
                                    x.accountNumber.split(' -')[0] ===
                                    selectedAccount
                            )!.address.street1
                        }
                        <br />
                        {Accounts.find(
                            (x) =>
                                x.accountNumber.split(' -')[0] ===
                                selectedAccount
                        )!.address.street2 != '' && (
                            <div>
                                {
                                    Accounts.find(
                                        (x) =>
                                            x.accountNumber.split(' -')[0] ===
                                            selectedAccount
                                    )!.address.street2
                                }{' '}
                                <br />
                            </div>
                        )}
                        {
                            Accounts.find(
                                (x) =>
                                    x.accountNumber.split(' -')[0] ===
                                    selectedAccount
                            )!.address.city
                        }
                        {', '}
                        {
                            Accounts.find(
                                (x) =>
                                    x.accountNumber.split(' -')[0] ===
                                    selectedAccount
                            )!.address.state
                        }{' '}
                        -{' '}
                        {
                            Accounts.find(
                                (x) =>
                                    x.accountNumber.split(' -')[0] ===
                                    selectedAccount
                            )!.address.postalCode
                        }
                    </p>
                </>
            )}
        </div>
    );
};
export default AccountSelector;
